import React from "react";
import PropTypes from "prop-types";

// Reoccurrence of Use Policy Component
export const ReoccurrencePolicyPage = ({ signatureData }) => {
  const currentDate = new Date().toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
  return (
    <div
      style={{
        fontFamily: "Elef Layla MF",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.2",
        fontSize: "16pt",
        height: "700px",
      }}
    >
      {/* Title */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <h2
          style={{
            fontSize: "18pt",
            // fontWeight: 'bold',
            borderBottom: "2px solid black",
            display: "inline-block",
          }}
        >
          Reoccurrence of use Policy
        </h2>
      </div>

      <section style={{ marginBottom: "20px" }}>
        <p style={{ marginBottom: "15px" }}>
          <span style={{ textDecoration: "underline", fontsize: "14px" }}>
            POLICY:{" "}
          </span>{" "}
          It is the policy of Legacy Healing Center Margate that any client who
          returns to active drug use as evidenced by a positive urine drug
          screen, refusal to comply with a random/suspicious drug screen or
          self-admission be discharged from the program and referred to a safe
          place immediately.
        </p>

        <h2 style={{ fontSize: "14pt", marginBottom: "10px" }}>PROCEDURE:</h2>
        <ol
          style={{
            paddingLeft: "40px",
            marginBottom: "15px",
            marginTop: "15px",
            fontFamily: "arial",
            fontSize: "12pt",
          }}
        >
          <li style={{ marginBottom: "10px" }}>
            In the event of a relapse the clients may be asked to move to a
            separate unit, move up in their level of care. If client refuses,
            they will be immediately removed from premises, client will be
            allowed no more than 2 hours to pack and leave property.
          </li>
          <li style={{ marginBottom: "10px" }}>
            They will be according to prearrangements with the facility from
            which they came, returned to that facility, brought to a detox
            facility, an emergency room for treatment or taken to a shelter.
          </li>
          <li style={{ marginBottom: "10px" }}>
            Their family will be immediately notified. Under no circumstances
            will they be permitted to remain in Legacy Healing Center Margate
            house as this will jeopardize the sobriety of the community.
          </li>
          <li style={{ marginBottom: "10px" }}>
            If the client has no resources to enter a higher level of care,
            re-admission will be considered once the client is able to comply
            with a negative urine drug screen.
          </li>
        </ol>

        <p style={{ marginBottom: "15px" }}>
          By signing this statement agree to the above terms.
        </p>
      </section>

      <div
        style={{
          // marginTop: "90px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "30px" }}>
            <img
              src={signatureData || ""}
              alt="Client Signature"
              style={{
                width: "200px",
                height: "70px",
                borderBottom: "1px solid black",
              }}
            />
            <p>
              <span>Client Signature:</span>
            </p>
          </div>
        </div>
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "20px", marginTop: signatureData ? "60px" : "0", }}>
            {/* {!currentDate && ( */}
            <div>{currentDate}</div>
            <div
              style={{
                borderBottom: "1px solid black",
                width: "300px",
                // height: "30px",
              }}
            ></div>
            {/* )} */}
            <p>Date:</p>
          </div>
        </div>
      </div>
      <hr
        style={{
          // marginTop: "50px",
          border: "none",
          borderTop: "1px solid black",
        }}
      />
    </div>
  );
};

ReoccurrencePolicyPage.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
};

// Maintenance Policy Component
export const MaintenancePolicyPage = ({ signatureData }) => {
  const currentDate = new Date().toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
  return (
    <div
    style={{
        fontFamily: "Elef Layla MF",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.2",
        fontSize: "16pt",
        height: "500px",
      }}
  >
      {/* Title */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <h2
          style={{
            // fontFamily: "Arial",
            fontSize: "16pt",
            // fontWeight: "bold",
            paddingBottom: "5px",
            borderBottom: "2px solid black",
            display: "inline-block",
          }}
        >
          MAINTENANCE POLICY
        </h2>
      </div>

      <section style={{ marginBottom: "20px" }}>
        <h2
          style={{
            fontSize: "14pt",
            // fontWeight: "bold",
            marginBottom: "10px",
            textDecoration: "underline",
          }}
        >
          POLICY:
        </h2>
        <p style={{ marginBottom: "15px" }}>
          It is the policy of Legacy Healing Center Margate, LLC to respond to
          all maintenance repair request forms within 48 hours.
        </p>

        <h2
          style={{ fontSize: "14pt", fontWeight: "bold", marginBottom: "10px" }}
        >
          PROCEDURE:
        </h2>
        <ol style={{ paddingLeft: "20px", marginBottom: "15px",fontFamily: "arial",fontSize: "12pt",marginLeft: "20px" }}>
          <li style={{ marginBottom: "10px" }}>
            Maintenance repair request forms are in each apartment.
          </li>
          <li style={{ marginBottom: "10px" }}>
            Residents and staff are expected to fill out a maintenance repair
            request form immediately upon recognition of an appliance, fixture
            or utility that is not working/functioning as intended.
          </li>
          <li style={{ marginBottom: "10px" }}>
            Staff will access the repair request and coordinate resolution
            within 48 hours.
          </li>
        </ol>
      </section>

      <div
        style={{
          marginTop: "30px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "30px" }}>
            <img
              src={signatureData || ""}
              alt="Client Signature"
              style={{
                width: "200px",
                height: "70px",
                borderBottom: "1px solid black",
              }}
            />
            <p>
              <span>Client Signature:</span>
            </p>
          </div>
        </div>
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "20px", marginTop: signatureData ? "60px" : "0", }}>
            {/* {!currentDate && ( */}
            <div>{currentDate}</div>
            <div
              style={{
                borderBottom: "1px solid black",
                width: "300px",
                // height: "30px",
              }}
            ></div>
            {/* )} */}
            <p>Date:</p>
          </div>
        </div>
      </div>
    </div>
  );
};

MaintenancePolicyPage.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
};
